import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import draftToHtml from 'draftjs-to-html';
import { API } from '../../config/api'
import eye from '../../assets/images/eye.png'
import eyeview from '../../assets/images/view.png'
import "../../assets/css/download.css"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';

const DownloadView = () => {

    const [formData, setFormData] = useState([]);
    const [title, setTitle]=useState('');
    const [subtitle, setSubtitle]=useState('');
    const ref=useRef();

    useEffect(()=>{
        let storedData=localStorage.getItem('data');
        console.log(JSON.parse(storedData))
        if(storedData){
        setTitle(JSON.parse(storedData)?.title)
        setSubtitle(JSON.parse(storedData)?.subtitle)
        setFormData(JSON.parse(storedData)?.fields)
        // localStorage.removeItem('data')
        }
    },[])

    // useEffect(()=>{
    //     if(formData[0]?.field_type_id!==undefined)
    //     console.log('start')
    //     const input=ref.current;
    //     html2canvas(input).then((canvas)=>{
    //         const imgData=canvas.toDataURL('image/png');
    //         const pdf=new jsPDF('p','mm', 'a4', true);
    //         const pdfWidth=pdf.internal.pageSize.getWidth();
    //         const pdfHeight=pdf.internal.pageSize.getHeight();
    //         const imgWidth=canvas.width;
    //         const imgHeight=canvas.height;
    //         const ratio=Math.min(pdfWidth/imgWidth,pdfHeight/imgHeight);
    //         const imgX=(pdfWidth-imgWidth*ratio)/2;
    //         const imgY=0;
    //         pdf.addImage(imgData,'PNG',imgX,imgY,imgWidth*ratio,imgHeight*ratio);
    //         pdf.link(10,10,100, 10, {url: 'https:/beta.avenu.ai'});
    //         pdf.save('doc.pdf');
    //         setInterval(()=>{
    //             window.close();
    //         },[5000])
        
    //     })
    // },[formData])

    const convert=(item)=>{
        if (item.field_type_id === 9) {
            
            //checkbox renderer
            return (
            
                <div>
                  
                    <div style={{ marginBottom: '25px' }}>
                    
                    <div className='fonts-styless' dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} />
                    {item.field_options.map((option) => (
                        <div className='form-check my-3' key={option.id}>
                            <input
                                className='form-check-input autosize'
                                type='radio'
                                name={`flexRadioDefault_${item.id}`} // Use a unique name for each field
                                id={`flexRadioDefault_${option.form_field_id}_${option.id}`} // Use a unique id for each option
                                checked={item?.interviewee_answer === option.options}
                                value={option.options}
                              />
                            <label className='form-check-label' htmlFor={`flexRadioDefault_${option.form_field_id}_${option.id}`}>
                                {option.options}
                            </label>
                        </div>
                    ))}
                </div>
                </div>

            )
        }
        else if (item.field_type_id === 14) {
            return (
              <div >
                <div className='fonts-styless'
                  dangerouslySetInnerHTML={{
                    __html: draftToHtml(JSON.parse(item.field_value)),
                  }}
                />
                <div class="form-floating ">
                   {/* <div class="input-group-append pass-div-width secure-field">
                             <input className ="form-control pass-inpt autosize" type='password' name='password' 
                              value={item?.interviewee_answer} />
                             <button type="button" class="btn eye-bttn" data-toggle="password">  */}
                        {/* <img src={item?.isVisible===false?eye:eyeview} alt="test" className="eye-img" /> */}
                       {/* <img src={eye} alt="test" className="eye-img" />
                        </button>
                              </div>  */}
                              
                            <span className='answr-Wrp' >{item?.interviewee_answer}</span>
                  
                </div>
              </div>
            );
          }
    //     else if (item.field_type_id === 3 || item.field_type_id === 4 || item.field_type_id === 5 || item.field_type_id === 7) {
    //         //image renderer, video render, esignature render and upload button render logics
            if (item.field_type_id === 4) {
                return (
                    <div>
                        <div className='fonts-styless' dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} />
                        <div className='img-divs '>
                            <video src={API.mediaView + item.file_path} alt="copy" className="video-thumb my-2 " controls />
                        </div>

                    </div>
                )
            }
            if (item.field_type_id === 5) {
                return (
                    <div className='chk-text mt-4'>
                        <div className="form-check wraper">
                            <input
                                className="form-check-input autosize"

                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                                checked={item?.is_accept_consent===1}/>
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                {item.field_value}
                            </label>
                        </div>
                        <div className='q-btns my-3 d-flex justify-content-between my-1 wraper'>
                            <div className='row w-100'>
                                <div className='col-lg-4 mb-4'>
                                    <div className="form-floating wraper minH mb-3 over-ride dowmloads">
                                        {/* <input
                                            type="text"
                                            className="form-control signs autosize sigs-down"
                                            id="signHereInput"
                                            placeholder="name@example.com"
                                            value={item?.interviewee_answer}/> */}
                                            <span className='answr-Wrp' >{item?.interviewee_answer}</span>
                                        {/* <label htmlFor="signHereInput" className=" font-enter-color" >Sign Here</label> */}
                                    </div>
                                </div>
                                <div className='col-lg-4 mb-4'>
                                    <div className="form-floating wraper minH mb-3 over-ride dowmloads">
                                        {/* <input type="text" className="form-control autosize years-down"
                                            value={ item?.consent_accepted_date === "0000-00-00" ? '': moment(item?.consent_accepted_date).format('MMMM D, YYYY')} /> */}
                                            <span className='answr-Wrp' >{item?.consent_accepted_date === "0000-00-00" ? '': moment(item?.consent_accepted_date).format('MMMM D, YYYY')}</span>
                                        {/* <label htmlFor="dateInput" className=" font-enter-color">Date</label> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            if (item.field_type_id === 7) {
                return (
                    <div className='two-buttn wraper upPsty'>
                        <div className='fonts-styless' dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} />
                        <div className='d-flex py-2 wraper'>
                            <div className="inpWid wraper">
                                <div className='inptFiles_up aligDivs_rev downz' style={{position: 'relative'}}>
                                    
                                    <div>
                                    {(item?.interviewee_document_path !== '' && item?.interviewee_document_path !== null) ? <p className='text-primary' onClick={()=>{openFile(API.mediaView + item?.interviewee_document_path)}} style={{cursor:'pointer'}}>{API.mediaView + item?.interviewee_document_path}</p>:<p className='text-danger'>No document uploaded</p>}
                                    {/* <p style={{zIndex: '0', margin:'8px 0px 0px 10px', float:'left'}}>{item?.interviewee_document_path?.split('/')?.pop()}</p> */}
                                    </div>
                            </div>
                                   </div>
                        </div>
                    </div>
                )
            }
            if (item.field_type_id === 3) {
            return (
                <div className='wraper'>
                    <div className='fonts-styless' dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} />
                    <div className={item.file_alignment==='left'?'img-divs divs-left-algment':item.file_alignment==='center'?'img-divs divs-center-algment':item.file_alignment==='right'?'img-divs divs-right-algment':null}>
                        <img className={item.file_alignment==='left' && item.file_size==='small'?"video-thumb my-2 imgs-left-algment image-sizes-small":item.file_alignment==='left' && item.file_size==='medium'?"video-thumb my-2 imgs-left-algment image-sizes-medm":item.file_alignment==='left' && item.file_size==='large'?"video-thumb my-2 imgs-left-algment image-sizes-large":item.file_alignment==='center' && item.file_size==='small'?"video-thumb my-2 imgs-center-algment image-sizes-small":item.file_alignment==='center' && item.file_size==='medium'?"video-thumb my-2 imgs-center-algment image-sizes-medm":item.file_alignment==='center' && item.file_size==='large'?"video-thumb my-2 imgs-center-algment image-sizes-large":item.file_alignment==='right' && item.file_size==='small'?"video-thumb my-2 imgs-right-algment image-sizes-small":item.file_alignment==='right' && item.file_size==='medium'?"video-thumb my-2 imgs-right-algment image-sizes-medm":item.file_alignment==='right' && item.file_size==='large'?"video-thumb my-2 imgs-right-algment image-sizes-large":null} src={API.mediaView + item.file_path} alt='form-dep' />
                    </div>

                </div>
            )
        }
       if (item.field_type_id === 11) {
            return (
                <div className='row w-100'>
                    <div className='col-lg-12'>
                        <p><div className='fonts-styless' dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} /></p>
                        <div className="btnAlg_same divz-width">
                            {/* <button className='btn btn-primary my-2 confirm-btn'>
                                Review Document
                            </button> */}
                            <p className='text-primary' onClick={()=>{openFile(API.mediaView + item?.file_path)}} style={{cursor:'pointer'}}>{API.mediaView + item?.file_path}</p>
                        </div>
                    </div>
                </div>
            )
        }
    //     // else if (item.field_type_id === 22) {
    //     //     return (
    //     <div className='row w-100'>
    //         <div className='col-lg-4 mb-4'>
    //             <div className='document-view'>
    //                 <h2>please fill the form</h2>
    //             </div>
    //         </div>
    //     </div>
    //     //     )
    //     // }

        if (item.field_type_id === 1) {
            return (
                <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} />
            )
        }
        if (item.field_type_id === 2) {
            return (
                <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} />
            )
        }
        if (item.field_type_id === 6) {
            return (
                <div className='mb-4'>
                    <div className='fonts-styless' dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.field_value)) }} />
                    <div class="form-floating">
                        {/* <textarea
                            className="form-control "
                            placeholder="Leave a comment here"
                            id="floatingTextarea"
                            value={item?.interviewee_answer}/> */}
                            <span className='answr-Wrp' >{item?.interviewee_answer}</span>
                        {/* <label htmlFor="floatingTextarea" className='font-enter-color'>Enter text here</label> */}
                    </div>
                </div>
            );
        }
    }

    const openFile=(path)=>{
        const link = document.createElement("a");
        link.href = path;
        link.download = "avenu";
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        onAfterPrint:()=>{
            window.close();
        }
      });
  return (
    <div className='mb-6' style={{paddingBottom:'80px'}}>
    <button onClick={handlePrint} className='print-pdf'>Print as PDF</button>
    <div className='me-3 mb-4 rev-padd-tap doct-view' ref={ref}>
        <p className='f-name'>{title}</p>
        <p className='sub-name'>{subtitle}</p>
     {formData.map((item)=>{
        return(
            convert(item)
        )
     })}
    </div>
    </div>
  )
}

export default DownloadView